<template>
  <div class="level-description-area">
    <div class="ad-slot my-2">
      <Adsense
        data-ad-client="ca-pub-8053105940003886"
        data-ad-slot="2116598501"
        data-ad-format="horizontal"
        :data-full-width-responsive="responsiveAd"
        ins-style="display:block; width: auto; height: 120px;"
      >
      </Adsense>

    </div>
    <!-- <div class="prut"></div> -->
    <h2 class="headline my-3 exercise-title">{{ exercise.title }}</h2>
    <div
      class="subheading exercise-description"
      v-html="exercise.description.split('\n').map(s => `<p>${s}</p>`).join('\n')"
    ></div>
    <div class="start-game-button mt-3">
      <v-btn
        v-show="userLevels.length"
        @click="startExercise(exercise)"
        round
        block
        large
        class="teal"
        dark
        >Start</v-btn
      >
    </div>
  </div>
</template>

<script>
import slugify from "slugify";
import { pathToFileURL } from "url";
export default {
  name: "levelDescriptionArea",
  data() {
    return {
      responsiveAd: true,
    };
  },
  methods: {
    startExercise(exercise) {

      // Set flag that user came from start button
      this.$store.dispatch('setNavigatedFromStartButton', true);

      let exerciseSlug = slugify(this.exercise.title, {
        replacement: "-",
        remove: /[*/+~.()'",!:@]/g,
        lower: true,
      }).replace(/#/g, "-sharp-");

      let pathToExercise;
      if (this.userExerciseType === "standard") {
        pathToExercise = `${this.$route.path}/exercise/${exerciseSlug}`;
      } else {
        pathToExercise = `${this.$route.path}/exercise/user/${exerciseSlug}`;
      }

      this.$router.push({
        path: pathToExercise,
        params: { id: exerciseSlug },
      });
    },
  },
  computed: {
    exercise() {
      if (this.userLevels.length) {
        return this.$store.getters.getExerciseInfo;
      } else {
        return {
          title: "",
          description:
            "",
        };
      }
    },
    userLevels() {
      return this.$store.getters.getExerciseList;
    },
    userExerciseType() {
      return this.$store.getters.getShowLevels;
    },
    AdInsStyle() {
      // return 'display:inline-block;height:90px';
      if (this.$vuetify.breakpoint.smOnly) {
        return "display:inline-block;width:250px;height:120px";
      }
      if (this.$vuetify.breakpoint.mdAndUp) {
        return "display:block;";
      }
      return "display:inline-block;width:300px;height:120px";
    },
  },
};
</script>

<style>
.level-description-area .exercise-description {
  text-align: center;
  max-height: calc(60vh - 100px);
  overflow-y: auto;
  padding-right: 10px;
}
.level-description-area .start-game-button {
  width: 100%;
}

.level-description-area .exercise-title {
  text-align: center !important;
}
.level-description-area .ad-slot {
  text-align: center;
}
</style>
